import {
  AdobeDataLayer,
  FutureActivityResponse,
  GenericLabel,
  getGenericLabel,
  USER_LOGGED_IN_STATUS
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  ANALYTICS_DATA_NAMES,
  TYPE
} from '../../models/constants/status-tracker/status.tracker.constants';
import {
  LoyaltyMemberTierLevel,
  StatusTrackerResponse
} from '../../models/interfaces/status-tracker/api/api-status-tracker.interfaces';
import { Tracker as TrackerContent } from '../../models/interfaces/status-tracker/status-tracker.interfaces';
import { getThreshold, getTierName, getYear } from './earnometer.utils';

declare const window: {
  adobeDataLayer: AdobeDataLayer[];
} & Window;

export const getHeader = (
  futureMedallionData: LoyaltyMemberTierLevel,
  aem: TrackerContent
): GenericLabel => {
  return getGenericLabel(
    `${getYear(futureMedallionData.tierLevelStartLocalDate as string)} ${
      aem?.statusProgressLabel
    }`,
    futureMedallionData?.tierLevelCodeDesc || ''
  );
};

export const setInitialData = (
  futureActivities: FutureActivityResponse | undefined,
  api: StatusTrackerResponse
) => {
  const tier = getTierName(
    api.loyaltyMemberTierLevels?.filter(
      (tier) => tier.tierStatusDesc === TYPE.CURRENT
    )
  );

  const pending = (
    futureActivities?.totalFutureBalances
      ? futureActivities.totalFutureBalances.find(
          (balance) => balance.balanceTypeCode === TYPE.MQD
        )?.balanceAmt
      : 0
  ) as number;

  const mqdThreshold = getThreshold(
    api.currentLoyaltyMemberMedallionStatus,
    TYPE.MQD
  );

  const futureMedallionData = api.loyaltyMemberTierLevels.find(
    (tier) => tier.tierStatusDesc === TYPE.FUTURE
  );
  return { futureMedallionData, tier, pending, mqdThreshold };
};

export const setTrackerErrorAnalyticsData = (errorMessage: string): void => {
  let analyticsData: AdobeDataLayer = {} as AdobeDataLayer;
  analyticsData = {
    event: ANALYTICS_DATA_NAMES.event,
    event_detail: ANALYTICS_DATA_NAMES.errorEventDetail,
    user: {
      attributes: { is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED }
    },
    error: {
      type: ANALYTICS_DATA_NAMES.errorType,
      code: ANALYTICS_DATA_NAMES.emptyString,
      message: errorMessage
    }
  };

  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(analyticsData);
};
